import { FullBuildingModel, mapDeviceSlice } from "./mapDeviceSlice";
import { RootState } from "../../app/state";
import { createSelector } from "@reduxjs/toolkit";
import {
  calculateNewPathRelativePointCoordinates,
  calculateNewRelativePointCoordinates,
  convertStringGeoCoordinateToNumber
} from "../../helpers/coordinatesHelpers";
import DeviceModel from "../../models/DeviceModel";
import MapModel from "../../models/MapModel";
import { isMapPointsSet } from "../../helpers/mapHelpers";

// const selectRoot = (state: RootState) => state;

export const selectMapDeviceState = (state: RootState) => state[mapDeviceSlice.name];

export const selectDeviceMapStructure = createSelector(
  selectMapDeviceState,
  (state) => state.deviceStructure
);

function iterateThroughStructure(deviceStructure: FullBuildingModel[], fn: (deviceModel: DeviceModel) => void) {
  (deviceStructure || []).forEach((building) => {
    (building.floorList || []).forEach((floor) => {
      (floor.deviceList || []).forEach((device) => {
        fn(device);
      })
    })
  });
}

export const selectLocationIndoorDeviceList = (currentMap?: MapModel | null) => createSelector(
  selectDeviceMapStructure,
  (deviceStructure) => {
    const locationInnerDeviceList: DeviceModel[] = [];
    const isPositioned = isMapPointsSet(currentMap);

    iterateThroughStructure(deviceStructure, (device) => {
      const deviceToPush = {
        ...device,
        configuration: {
          ...device.configuration,
          mapPath: device.configuration.mapPath ? {
            ...device.configuration.mapPath,
            // @ts-ignore
            path: isPositioned ? calculateNewPathRelativePointCoordinates(device.configuration.mapPath.path, currentMap) : null,
          } : null,
          mapPoint: device.configuration.mapPoint ? {
            ...device.configuration.mapPoint,
            // @ts-ignore
            mapPoint: device.configuration.mapPoint?.geoPoint && isPositioned ? calculateNewRelativePointCoordinates(convertStringGeoCoordinateToNumber(device.configuration.mapPoint?.geoPoint), currentMap) : null,
          } : null,
        }
      }

      // @ts-ignore
      locationInnerDeviceList.push(deviceToPush);
    })

    return locationInnerDeviceList;
  }
);

export const selectWirelessSystemListFromIndoorDevices = createSelector(
  selectDeviceMapStructure,
  (deviceStructure) => {
    const wirelessSystemIdList: number[] = [];
    iterateThroughStructure(deviceStructure, (device) => {
      if (device?.configuration?.wirelessSystemId && !(wirelessSystemIdList.includes(device?.configuration?.wirelessSystemId))) {
        wirelessSystemIdList.push(device?.configuration?.wirelessSystemId);
      }
    });

    return wirelessSystemIdList;
  }
);

export const selectTechnologyListFromIndoorDevice = createSelector(
  selectDeviceMapStructure,
  (deviceStructure) => {
    const technologyConfigurationList: number[] = [];

    iterateThroughStructure(deviceStructure, (device) => {
      (device?.configuration?.wirelessInterfaces || []).forEach((wirelessInterface) => {
        if (wirelessInterface.technologyConfigurationId && !technologyConfigurationList.includes(wirelessInterface.technologyConfigurationId)) {
          technologyConfigurationList.push(wirelessInterface.technologyConfigurationId);
        }
      })
    });

    return technologyConfigurationList;
  }
);